import { GET_COUNTRIES } from "@/actions/GET_COUNTRIES.ts";
import { Country } from "@/helpers/types/types.ts";
import { useQuery } from "@apollo/client";

export interface GetCountriesResponse {
  countries: Country[];
}
export const useGetCountries = () => {
  const { data, loading } = useQuery<GetCountriesResponse>(GET_COUNTRIES);

  return {
    countries: data?.countries || [],
    getCountriesLoading: loading,
  };
};
